var _defs, _path, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.662,
    height: 10.662,
    viewBox: "0 0 10.662 10.662",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.331,0a5.331,5.331,0,1,0,5.331,5.331A5.328,5.328,0,0,0,5.331,0Zm0,9.829a4.5,4.5,0,1,1,4.5-4.5A4.5,4.5,0,0,1,5.331,9.829Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.915 4.463)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M236.416,214.33a.416.416,0,0,0-.416.416v2.682a.416.416,0,0,0,.833,0v-2.682A.416.416,0,0,0,236.416,214.33Z",
    transform: "translate(-236 -214.33)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.769 2.829)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.562,
    cy: 0.562,
    r: 0.562
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.e34eb4a27c15e50652320945fd70d60e.svg";
export { ForwardRef as ReactComponent };